import { EVENTS_SYSTEM_NAME, USER_INTERACTION_EVENT } from "@zapier/utils";
import emitEvent from "./emitEvent";

export enum UserInteractionName {
  Favorite = "favorite_interaction",
  AgentDeleteModal = "agent_delete_modal",
  AgentKebab = "agent_kebab_interaction",
  ColumnResize = "column_resize",
  AppSearch = "app_search_interaction",
  AppTable = "app_table_interaction",
  AssetRowInteraction = "asset_row_interaction",
  AssetSidebarResize = "asset_sidebar_resize",
  CanvasKebab = "canvas_kebab_interaction",
  CanvasDeleteModal = "canvas_delete_modal",
  CanvasRenameModal = "canvas_rename_modal",
  CanvasChangeOwnerModal = "canvas_change_owner_modal",
  CanvasAiPrompt = "canvas_ai_prompt",
  ConnectionChangeOwnerModal = "connection_change_owner_modal",
  ConnectionKebab = "connection_kebab_interaction",
  ManagedConnectionCreateClicked = "managed_connection_create_clicked",
  ManagedConnectionCreated = "managed_connection_created",
  ManagedConnectionCreateAbandoned = "managed_connection_create_abandoned",
  ChatbotDeleteModal = "chatbot_delete_modal",
  ChatbotChangeOwnerModal = "chatbot_change_owner_modal",
  ChatbotRenameModal = "chatbot_rename_modal",
  ChatbotKebab = "chatbot_kebab_interaction",
  ConnectionSearch = "connection_search_interaction",
  FavoritesSearchInteraction = "favorites_search_interaction",
  FolderAction = "folder_action",
  FolderAssetSort = "folder_asset_sort",
  FolderDocumentation = "folder_documentation",
  FolderSearchInteraction = "folder_search_interaction",
  InterfaceKebab = "interface_kebab_interaction",
  ProjectAction = "project_action",
  SetDefaultView = "set_default_view",
  ShareUpsell = "share_upsell",
  TableKebab = "table_kebab_interaction",
  TemplateDuplicateModal = "template_duplicate_modal",
  TemplateKebab = "template_kebab_interaction",
  ZapBulkAction = "zap_bulk_action",
  ZapKebab = "zap_kebab_interaction",
  ZapRowToggle = "zap_row_toggle_zap",
  ZapSearchInteraction = "zap_search_interaction",
  GlobalSearch = "global_search_interaction",
  ZapsPageOptOut = "zaps_page_opt_out",
  TableDeleteModal = "table_delete_modal",
  TableRenameModal = "table_rename_modal",
  TableChangeOwnerModal = "table_change_owner_modal",
  InterfaceDeleteModal = "interface_delete_modal",
  InterfaceDuplicateModal = "interface_duplicate_modal",
  InterfaceRenameModal = "interface_rename_modal",
  ShareModal = "share_modal",
  CopyToAnotherAccount = "copy_to_another_account",
  ZapListSort = "zap_list_sort",
  ZapCreate = "zap_create",
  TrashNavClick = "trash_nav_click",
  NextGenZapsHeaderCreateCta = "next_gen_zaps_header_create_cta",
  NextGenZapsEmptyStateCreateCta = "next_gen_zaps_empty_state_create_cta",
  NextGenZapsEmptyState = "next_gen_zaps_empty_state",
  NextGenZapRowToggle = "next_gen_zap_row_toggle",
  NextGenZapKebab = "next_gen_zap_kebab_interaction",
  NextGenZapRenameModal = "next_gen_zap_rename_modal",
  NextGenZapDuplicateModal = "next_gen_zap_duplicate_modal",
  NextGenZapChangeOwnerModal = "next_gen_zap_change_owner_modal",
  NextGenZapDeleteModal = "next_gen_zap_delete_modal",
  NextGenFormCreate = "next_gen_form_create",
}

export interface EmitUserInteractionEvent {
  accountId?: number;
  customTrackingFields?: any;
  eventAction?: "click" | "edit" | "view" | "in_view";
  interactionGoal?: string;
  interactionLocation?: string;
  interactionName: UserInteractionName;
  interactionRawText?: string;
  optionSelected?: string;
  systemName?: string;
}

const emitUserInteractionEvent = ({
  accountId,
  customTrackingFields = {},
  eventAction = "click",
  interactionGoal = "",
  interactionLocation,
  interactionName,
  interactionRawText = "",
  optionSelected = "",
  systemName,
}: EmitUserInteractionEvent) =>
  emitEvent(USER_INTERACTION_EVENT, {
    account_id: accountId,
    custom_tracking_fields: customTrackingFields,
    event_action: eventAction,
    interaction_goal: interactionGoal,
    interaction_location: interactionLocation,
    interaction_name: interactionName,
    interaction_raw_text: interactionRawText,
    option_selected: optionSelected,
    system_name: systemName || EVENTS_SYSTEM_NAME,
  });

export default emitUserInteractionEvent;
